/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import { View, TouchableOpacity, StyleSheet, ScrollView } from 'react-native';

import Checkbox from './Checkbox';
import ClickAway from './ClickAway';
import { themeColors } from './Constants';
import Hoverable from './Hoverable';
import Text from './Text';
import TextInputSearch from './TextInputSearch';

type OptionsContent = { fieldID: string; name: string };

type State = {
  showPicker: boolean;
  pickerWidth: number;
};

type Props = {
  style?: StyleSet;
  filterText: string;
  isDisabled?: boolean;
  options: ReadonlyArray<string | OptionsContent>;
  selectedItem: Set<string>;
  onSelectAll: () => void;
  onChange: (arg0: string) => void;
  fixedPickerWidth?: boolean;
  onFilterTextChange: (arg0: string) => void;
};

type ItemProps = {
  title: string;
  selected: boolean;
  onPress: (arg0: string) => void;
  style?: StyleSet;
};

function Item({ title, style, selected, onPress }: ItemProps) {
  return (
    <Hoverable
      render={(isHovered, eventHandlers) => (
        <View>
          <View
            style={[styles.item, isHovered && styles.itemHovered, style]}
            {...eventHandlers}
          >
            <Checkbox
              text={title}
              isChecked={selected}
              onChange={() => {
                onPress(title);
              }}
            />
          </View>
        </View>
      )}
    />
  );
}

class FilterablePicker extends Component<Props, State> {
  state: State = {
    pickerWidth: 0,
    showPicker: false,
  };

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.state.showPicker !== prevState.showPicker) {
      this.props.onFilterTextChange('');
    }
  }

  render() {
    let {
      style,
      options,
      filterText,
      selectedItem,
      fixedPickerWidth,
      isDisabled,
    } = this.props;
    let { pickerWidth, showPicker } = this.state;
    let onPickerPress = showPicker ? this._hidePicker : this._showPicker;
    let filteredOptions = this._getFilteredOptions();
    return (
      <View>
        <Hoverable
          render={(isHovered, eventHandlers) => (
            <TouchableOpacity
              onPress={onPickerPress}
              activeOpacity={0.6}
              disabled={isDisabled}
            >
              <View
                {...eventHandlers}
                style={[styles.root, isHovered && styles.hoveredRoot, style]}
                onLayout={({
                  nativeEvent: {
                    layout: { width },
                  },
                }) => {
                  this.setState({ pickerWidth: width });
                }}
              >
                <Text
                  type="label"
                  numberOfLines={1}
                  style={
                    {
                      textOverflow: 'ellipsis',
                      color: themeColors.blue,
                      fontWeight: '600',
                    } as any
                  }
                >
                  {selectedItem.size} Selected
                </Text>
              </View>
            </TouchableOpacity>
          )}
        />
        {showPicker && (
          <ClickAway onClickAway={onPickerPress}>
            <View
              style={[
                styles.picker,
                !fixedPickerWidth && { width: pickerWidth },
              ]}
            >
              <View style={{ width: pickerWidth - 30, marginVertical: 10 }}>
                <TextInputSearch
                  value={filterText}
                  onChangeText={(value) => {
                    this.props.onFilterTextChange(value);
                  }}
                />
              </View>
              <View style={{ width: pickerWidth - 30 }}>
                <ScrollView style={{ maxHeight: 180 }}>
                  <View style={styles.item}>
                    <Checkbox
                      text="Select All"
                      isChecked={options.length === selectedItem.size}
                      onChange={this.props.onSelectAll}
                    />
                  </View>
                  {filteredOptions.map((item, i) => {
                    let selected =
                      typeof item === 'string'
                        ? selectedItem.has(item)
                        : selectedItem.has(item.fieldID);
                    return this._renderItem(i, item, selected);
                  })}
                </ScrollView>
              </View>
            </View>
          </ClickAway>
        )}
      </View>
    );
  }

  _renderItem = (
    i: number,
    item: string | { fieldID: string; name: string },
    isChecked: boolean,
  ) => {
    let selection = typeof item === 'string' ? item : item.fieldID;
    let name = typeof item === 'string' ? item : item.name;
    return (
      <Item
        key={i}
        selected={isChecked}
        title={name}
        onPress={() => this.props.onChange(selection)}
      />
    );
  };

  _showPicker = () => {
    this.setState({
      showPicker: true,
    });
  };

  _hidePicker = () => {
    this.setState({
      showPicker: false,
    });
  };

  _getFilteredOptions = (): ReadonlyArray<string | OptionsContent> => {
    let { options, filterText } = this.props;
    if (!filterText) {
      return options;
    }
    let loweredText = filterText.toLowerCase();

    let result = options.filter((el) => {
      let name = typeof el === 'string' ? el : el.name;
      let elString = name.toLowerCase();
      if (elString.includes(loweredText)) {
        return true;
      } else {
        return false;
      }
    });
    return result.length > 0 ? result : [];
  };
}

let itemHeight = 30;
let styles = StyleSheet.create({
  root: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: 34,
    paddingLeft: 12,
    paddingRight: 6,
    backgroundColor: themeColors.white,
    borderWidth: StyleSheet.hairlineWidth,
    borderRadius: 3,
    borderColor: themeColors.borderGrey,
    maxWidth: 280,
  },
  hoveredRoot: {
    backgroundColor: themeColors.lightGrey,
  },
  picker: {
    position: 'absolute',
    top: 34,
    left: 0,
    alignItems: 'center',
    marginTop: 10,
    paddingVertical: 5,
    backgroundColor: themeColors.white,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: themeColors.borderGrey,
    borderRadius: 3,
  },
  item: {
    height: itemHeight,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingHorizontal: 10,
  },
  itemHovered: {
    backgroundColor: themeColors.withOpacity.blue8,
  },
});

export default FilterablePicker;
